<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column w-60pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "setup_cost_centre_msg_1" | translate }}</h2>
                <app-video-icon [VideoUrl]="howDoIVideoLinks.costCentreCustomerOnOff | safeUrl"></app-video-icon>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning mr-2"
                    (click)="fnShowConfigureshowLoggingAlertPanel()">
                    {{ "label_log" | translate }}
                </button>
                <button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{'disabled':!hasFormChanges}"
                    (click)="Save()">
                    {{ "label_save" | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="backToSettings()">
                    {{ "label_close" | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2">
                <div class="d-flex justify-content-between align-items-center gap-3">
                    <div>
                        <h6 class="fw-700"> {{ "self_setup_16_msg_9" | translate }}</h6>
                        <p>{{ "self_setup_16_msg_10" | translate }}</p>
                    </div>


                    <div class="d-flex">
                        <input type="checkbox" switch="bool" (change)="fnSetCostCentre(!isCostCentreOn,true)"
                            id="customSwitchCostCentre" [checked]="isCostCentreOn">
                        <label class="m-0" for="customSwitchCostCentre"></label>
                    </div>
                </div>
            </div>
            <div class="block mt-2">
                <div class="d-flex justify-content-between align-items-center gap-3"
                    [ngClass]="{'customer-not-available': !isCustomerFeatureAvailable()}"
                    (click)="onCustomerSectionClick()">
                    <div>
                        <h6 class="fw-700">{{ "self_setup_16_msg_11" | translate }}</h6>
                    </div>
                    <div class="d-flex">
                        <input type="checkbox" switch="bool" (change)="fnSetCustomer(!isCustomerOn,true)"
                            id="customSwitchCustomer" [checked]="isCustomerOn"
                            [disabled]="!isCustomerFeatureAvailable()">
                        <label class="m-0" for="customSwitchCustomer"></label>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Alert Panel for Confirmation -->
<app-alert-panel [data]="alertPanelModel" (callbackEvent)="alertPanelReceiver($event)">
</app-alert-panel>

<!-- Marketing Popup -->
<marketing-popup *ngIf="showMarketingPopup" [data]="marketingPopupModel" (closePanel)="showMarketingPopup=false">
</marketing-popup>

<!-- Approval Rule Panel -->
<approval-rule *ngIf="showApprovalRulePanel" (closePanelEvent)="closeApprovalRulePanel($event)">
</approval-rule>